import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getEnv } from "./env";

const firebaseConfig = {
  apiKey: getEnv("VITE_FIREBASE_API_KEY"),
  authDomain: getEnv("VITE_FIREBASE_AUTH_DOMAIN"),
  projectId: getEnv("VITE_FIREBASE_PROJECT_ID"),
  storageBucket: getEnv("VITE_FIREBASE_STORAGE_BUCKET"),
  messagingSenderId: getEnv("VITE_FIREBASE_MESSAGING_SENDER_ID"),
  appId: getEnv("VITE_FIREBASE_APP_ID"),
};

if (!firebaseConfig.apiKey) {
  throw new Error(
    "Firebase configuration missing. Please check your .env file.",
  );
}

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
